import type { GuidedSelfHelpRouteName, RouterConfig } from '../../containers/Routes/types';

// Pages.
import PageNursePractitionerAccountDetails from './Details';
import PageNursePractitionerChangeEmail from './ChangeEmail';
import PageNursePractitionerChangePassword from './ChangePassword';

const routesConfigNursePractitionerAccount: RouterConfig<GuidedSelfHelpRouteName> = {
  accountBase: {
    basePath: '/account',
    nl: '/nl/account',
    type: 'private',
    component: PageNursePractitionerAccountDetails,
  },
  accountEmail: {
    basePath: '/account/email-wijzigen',
    nl: '/nl/account/email-wijzigen',
    type: 'private',
    component: PageNursePractitionerChangeEmail,
  },
  accountPassword: {
    basePath: '/account/wachtwoord-wijzigen',
    nl: '/nl/account/wachtwoord-wijzigen',
    type: 'private',
    component: PageNursePractitionerChangePassword,
  },
};

export default routesConfigNursePractitionerAccount;
